export interface IColumnWidth {
    value: number;
    type: 'fr' | 'px';
};

export interface IColumn {
    content: React.ReactNode;
    sortBy?: string;
    sortable?: boolean;
    width: IColumnWidth;
};

export enum PAGINATION_BUTTON_COLOR {
    THEME = 'theme',
    MUTED = 'muted',
}

export interface IPagination {
    page: number;
    perPage: number;
    onSetPage: (page: number) => void;
    total: number;
    buttonColor?: PAGINATION_BUTTON_COLOR;
};

export interface ISortButton {
    sortBy: string;
    sortedBy?: string;
    sortedByDir?: string;
};

export interface IPaginationButtonProps {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    isActive: boolean;
    activeColor: string;
};

export enum SORT_TYPES {
    ASC = 'asc',
    DESC = 'desc'
};

export enum TABLE_SPACING_VARIANT {
    DEFAULT = 'table-spacing-default',
    SMAll = 'table-spacing-small'
}
